import { SET_USER_PAGE_VIEW_ID_ACTION } from '@/actions/AnalyticsActions';
/** stateの初期値 */
const INITIAL_STATE = {
    pageViewId: null,
};
export const analytics = (state = INITIAL_STATE, result) => {
    switch (result.type) {
        case SET_USER_PAGE_VIEW_ID_ACTION: {
            // ページビューIDを更新
            return Object.assign(Object.assign({}, state), { pageViewId: result.payload.id });
        }
        default: {
            return state;
        }
    }
};
